import React, { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import ReactIdSwiperCustom from "react-id-swiper/lib/ReactIdSwiper.custom";
import BasicModal from "../../elements/basic-modal";
import { swiperParamsOneSlide, swiperParams } from "./config";
import "./style.scss";
import classNames from "classnames";
import { generateReactKey } from "../../utils/reactKey";

const ZOOM_FACTOR = 1.5;

const zoomImage = (evt, el) => {
  const { width, height, left, top } = evt.target.getBoundingClientRect();

  const mouseRelativeXPosition = (evt.pageX - left) / width;
  const mouseRelativeYPosition = (evt.pageY - top) / height;

  const mousePercentagePosition = {
    x: (mouseRelativeXPosition > 1 ? 1 : mouseRelativeXPosition) * 100,
    y: (mouseRelativeYPosition > 1 ? 1 : mouseRelativeYPosition) * 100
  };

  el.style.transform = `scale(${ZOOM_FACTOR})`;
  el.style.transformOrigin = `${mousePercentagePosition.x}% ${mousePercentagePosition.y}%`;
};

const resetZoomImage = el => {
  el.style.transform = "scale(1)";
  el.style.transformOrigin = "0% 0%";
};

const GearSelectionCarousel = ({ slides }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [config, setConfig] = useState(null);

  const sliderRef = useRef(null);
  const sliderInstance = useRef(null);

  const toggleModal = useCallback(() => {
    if(showModal){
      document.body.classList.remove("modal-open")
      // document.body.style.position = "relative";
      window.scrollTo(window.scrollBody,window.scrollBody); 
    }else{
      document.body.classList.add("modal-open");
      window.scrollBody= document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      // document.body.style.position = "fixed";
    }
    setShowModal(!showModal);
  }, [showModal]);

  useEffect(() => {
    if (config) {
      sliderInstance.current.loopDestroy();
      sliderInstance.current.loopCreate();
      sliderInstance.current.update();
    }
  }, [slides, config]);

  useEffect(() => {
    if (config) {
      const slideRefCurrent = sliderRef.current;

      slideRefCurrent.querySelectorAll(".slide-image").forEach(el => {
        el.addEventListener("mouseenter", evt => zoomImage(evt, el));
        el.addEventListener("mousemove", evt => zoomImage(evt, el));
        el.addEventListener("mouseleave", () => resetZoomImage(el));
        el.addEventListener("click", toggleModal);
      });
      return () => {
        slideRefCurrent.querySelectorAll(".slide-image").forEach(el => {
          el.removeEventListener("mouseenter", evt => zoomImage(evt, el));
          el.removeEventListener("mousemove", evt => zoomImage(evt, el));
          el.removeEventListener("mouseleave", () => resetZoomImage(el));
          el.removeEventListener("click", toggleModal);
        });
      };
    }
  }, [toggleModal, slides, config]);

  useEffect(() => {
    slides.length && setConfig(slides.length < 2 ? swiperParamsOneSlide : swiperParams);
  }, [slides.length]);

  if (config)
    return (
      <div
        className={classNames("gear-selector-carousel", {
          disable: slides.length < 2
        })}
      >
        <ReactIdSwiperCustom
          {...config}
          on={{
            slideChange() {
              setActiveSlide(this.realIndex);
            },
            init() {
              sliderInstance.current = this;
            }
          }}
          ref={sliderRef}
        >
          {slides.map(slide => (
            <div key={generateReactKey()}>
              <div
                className="slide-image"
                style={{
                  backgroundImage: `url(${slide.src})`
                }}
              />
            </div>
          ))}
        </ReactIdSwiperCustom>
        {showModal && (
          <BasicModal
            screenSettings={{
              fullWidth: false,
              fullScreen: true,
              fullHeight: false
            }}
            className="gear-selector-carousel__modal"
            onCloseClicked={() => toggleModal()}
          >
            <img className="gear-selector-carousel__modal-image" src={slides[activeSlide].src} alt={slides[activeSlide].alt} />
          </BasicModal>
        )}
      </div>
    );
  else return null;
};

GearSelectionCarousel.propTypes = {
  slides: PropTypes.array
};

export default GearSelectionCarousel;
